import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initPixel, trackPageView } from "../../utils/metaPixel";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export default function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (PIXEL_ID) {
      initPixel(PIXEL_ID);
    }
  }, []);

  useEffect(() => {
    if (PIXEL_ID) {
      trackPageView();
    }
  }, [location.pathname, location.search]);

  return null;
}
